import * as React from 'react';
import { Link } from 'react-router-dom';
import { JobCenterModelInterface } from '../Model/JobCenterModelInterface';
import { ReferenceIdContainerInterface } from '../ReferenceIdContainer';
import { RouteConstants } from '../RouteConstants';
import { Type } from '../Type';
import { ApplyNowButtonWidget } from './Button/ApplyNowButtonWidget';
import { SidebarItem } from './Sidebar/SidebarItem';
import { Trans } from './Trans';

export interface SidebarProps {
    type: Type;
    openModel: JobCenterModelInterface;
    models: JobCenterModelInterface[];
    multiSelect: boolean;
    selectedModels?: ReferenceIdContainerInterface;
}

export class Sidebar extends React.Component<SidebarProps> {
    public render() {
        const props = this.props;
        const models = this.filterModels(props.models, props.openModel);
        const selectedModels = props.selectedModels;
        const openModelReferenceId = props.openModel.referenceId;
        const type = props.type;

        return <aside className="job-center-sidebar col-sm-5">
            <div className="job-center-sidebar-top">
                {this.renderBackButton(type, '-top')}
                {this.renderApplyNowButton()}
            </div>
            <div className="job-center-sidebar-viewport">
                {models.map(
                    m => <SidebarItem type={type}
                                      model={m}
                                      key={m.referenceId}
                                      showSelector={props.multiSelect}
                                      selected={selectedModels !== undefined && selectedModels.contains(m.referenceId)}
                                      isOpen={m.referenceId === openModelReferenceId}/>
                )}
            </div>
            {this.renderBackButton(type, '-bottom')}
        </aside>;
    }

    private renderBackButton(type: Type, className: string) {
        const to = RouteConstants.routeForType(type);

        return <Link to={to} className={'jc-sidebar-button-overview ' + className}>
            <Trans>zurück zur Übersicht</Trans>
        </Link>;
    }

    private renderApplyNowButton() {
        const props = this.props;
        const selectedModels = props.selectedModels;
        if (props.multiSelect && selectedModels) {
            return <>
                <ApplyNowButtonWidget selectedModels={selectedModels}/>
            </>;
        } else {
            return null;
        }
    }

    private filterModels(
        models: JobCenterModelInterface[],
        openModel: JobCenterModelInterface
    ): JobCenterModelInterface[] {
        if (openModel.industry) {
            const referenceId = openModel.industry.referenceId;
            return models.filter(m => referenceId === m.industry?.referenceId);
        } else {
            return [];
        }
    }
}
